export type HumanQaStatus = 'pending' | 'approved' | 'rejected';

export interface HumanQaState {
  required: boolean;
  reasons: string[];
  status: HumanQaStatus;
  assigned_to?: string;
  reviewed_by?: string;
  reviewed_at?: string;
  notes?: string;
}

export interface HumanQaCarrier {
  generation_metadata?: {
    human_qa?: unknown;
  } & Record<string, unknown>;
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function getHumanQaState(content: HumanQaCarrier | null | undefined): HumanQaState | null {
  const raw = content?.generation_metadata?.human_qa;
  if (!isObject(raw)) return null;

  const required = raw.required === true;
  const reasons = Array.isArray(raw.reasons)
    ? raw.reasons.filter((reason): reason is string => typeof reason === 'string' && reason.trim().length > 0)
    : [];
  const status = raw.status === 'approved' || raw.status === 'rejected' ? raw.status : 'pending';

  return {
    required,
    reasons,
    status,
    assigned_to: typeof raw.assigned_to === 'string' ? raw.assigned_to : undefined,
    reviewed_by: typeof raw.reviewed_by === 'string' ? raw.reviewed_by : undefined,
    reviewed_at: typeof raw.reviewed_at === 'string' ? raw.reviewed_at : undefined,
    notes: typeof raw.notes === 'string' ? raw.notes : undefined,
  };
}

export function isPendingHumanQa(content: HumanQaCarrier | null | undefined): boolean {
  const humanQa = getHumanQaState(content);
  return humanQa?.required === true && humanQa.status !== 'approved';
}

export function humanQaReasonsText(humanQa: HumanQaState | null | undefined): string {
  const reasons = humanQa?.reasons.filter(Boolean) ?? [];
  return reasons.length > 0 ? reasons.join(', ') : 'review required';
}
